(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-showcase-slider"] && !Shopify.designMode) return;
  try {
    
  class FeatureShowcaseSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.carousel = this.querySelector('carousel-slider');
      this.slider = this.querySelector('.slider');
      this.slides = Array.from(this.querySelectorAll('.feature-showcase__slide'));
      this.prevButton = this.querySelector('button[name="prev"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.activeIndex = 0;

      if (!this.slider || this.slides.length === 0) return;

      this.handleSelect = this.handleSelect.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.addEventListener('on:carousel-slider:select', this.handleSelect);
      this.slides.forEach((slide, index) => {
        slide.addEventListener('click', () => this.scrollToIndex(index));
      });
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollToIndex(Math.max(this.activeIndex - 1, 0)));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollToIndex(Math.min(this.activeIndex + 1, this.slides.length - 1)));
      }

      requestAnimationFrame(() => {
        this.scrollToIndex(0, false);
      });
      this.initialized = true;
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('on:carousel-slider:select', this.handleSelect);
    }

    handleSelect(event) {
      this.setActiveSlide(event.detail.index);
    }

    handleBlockSelect(event) {
      const slide = event.target.closest('.feature-showcase__slide');
      if (!slide || !this.contains(slide)) return;
      const index = Number(slide.dataset.index);
      this.setActiveSlide(index);
      window.setTimeout(() => {
        this.scrollToIndex(index);
      }, 240);
    }

    scrollToIndex(index, smooth = true) {
      const target = this.slides[index];
      if (!target) return;

      const shouldCenter = window.matchMedia('(min-width: 768px)').matches;
      const desktopFocusPoint = Math.min(this.slider.clientWidth * 0.38, 360);
      const mobileInset = 10;
      const offset = shouldCenter
        ? target.offsetLeft - (desktopFocusPoint - (target.clientWidth / 2))
        : target.offsetLeft - mobileInset;
      this.slider.scrollTo({
        left: offset,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.setActiveSlide(index);
    }

    setActiveSlide(index) {
      this.activeIndex = index;
      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
    }
  }

  if (!customElements.get('feature-showcase-slider')) {
    customElements.define('feature-showcase-slider', FeatureShowcaseSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
